import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer} from 'recharts';
import { injectIntl, FormattedMessage } from 'react-intl';
import '../App.css';

class CustomTooltip  extends Component{

    getDate(date) {
      return new Date(date).toLocaleString(navigator.language || navigator.userLanguage);
    }
  
    getLabel(data)
    {
      return data.payload.description;
    }
  
    render() {
      const { active } = this.props;
  
      if (active) {
        const { payload } = this.props;
        if (!(payload instanceof Array) || payload.length <= 0) {
          return null;
        }

        return (
          <div className="custom-tooltip">
            <p className="custom-tooltip-line"><b>{this.getDate(payload[0].payload.changeDate)}</b></p>
            <p className="custom-tooltip-line"><b>{this.getLabel(payload[0])}</b></p>
            <p className="custom-tooltip-line"><FormattedMessage id="CustomTooltip.new_level"/>: <b>{payload[0].payload.currentLevel}</b></p>         
            <p className="custom-tooltip-line"><FormattedMessage id="SuppliesChangesTable.previous_level"/>: <b>{payload[0].payload.previousLevel}</b></p>         
            <p className="custom-tooltip-line"><FormattedMessage id="CustomTooltip.pages_count"/>: <b>{payload[0].payload.changePagesCount}</b></p>
          </div>
        );
      }
  
      return null;
    }
  }
   
  class SuppliesHistoryChart extends Component{
    constructor(props) {
      super(props);
  
      this.props.chartData.supplies.sort(function(a, b) {
        return a.changeDate < b.changeDate ? -1 : 1;
      });
  
      this.getLegend = this.getLegend.bind(this);
    }
    
    xAxisTickFormatter(date) {
      var options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      return new Date(date).toLocaleString(navigator.language || navigator.userLanguage, options);
    }
  
    getLegend(props)
    {
      let legend = this.props.chartData.name;
      if (this.props.chartData.model)
      {
        legend += '(' + this.props.chartData.model + ')';
      }
  
      return legend;
    }
  
      render () {
        const yLabel = this.props.intl.formatMessage({id: 'SuppliesHistoryChart.supply_level'});
        return (  
        <ResponsiveContainer height={300} width={'100%'}>
          <BarChart data={this.props.chartData.supplies}
              margin={{top: 20, right: 30, left: 20, bottom: 5}} maxBarSize = {100}>
         <XAxis dataKey="changeDate" tickFormatter={this.xAxisTickFormatter}/>
         <YAxis label={{ value: yLabel, angle: -90, position: 'insideLeft' }}/>
         <CartesianGrid strokeDasharray="3 3"/>
         <Tooltip content={<CustomTooltip/>}/>         
         <Bar dataKey="previousLevel" stackId="a" fill= "#888888"/>
         <Bar dataKey="currentLevel" stackId="b">
         {
             this.props.chartData.supplies.map((entry, index) => {
             return <Cell key = {index} fill={entry.color} />;
             })
         }
         </Bar>
        </BarChart>
        </ResponsiveContainer>
      )
    }
  }
  
  const propTypes = {
    intl: PropTypes.object.isRequired,
  };
  SuppliesHistoryChart.propTypes = propTypes;
  
  export default injectIntl(SuppliesHistoryChart, {
    withRef: true,
  });